import type { FC } from 'react'
import { Link } from 'react-router-dom'

import { Text } from 'components'

import type { TPortfolioCardProps } from './types'
import styles from './PortfolioCard.module.scss'

export type { TPortfolioCardProps }

const PortfolioCard: FC<TPortfolioCardProps> = ({ backgroundImage, title, date, tag, to }) => {
  const inner = (
    <>
      <img src={backgroundImage} alt={title} className={styles.wrapper__image} loading='lazy' />
      {tag && (
        <span className={styles.wrapper__tag}>
          <Text text={tag} />
        </span>
      )}
      <div className={styles.wrapper__content}>
        <h3 className={styles.wrapper__title}>{title}</h3>
        {date && <p className={styles.wrapper__date}>{date}</p>}
      </div>
      {to && <span className={styles.wrapper__arrow} aria-hidden />}
    </>
  )

  if (to) {
    return (
      <Link to={to} className={styles.wrapper} aria-label={title}>
        {inner}
      </Link>
    )
  }

  return <article className={styles.wrapper}>{inner}</article>
}

export default PortfolioCard
